import React from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

export default class Checkbox extends React.Component {
  static propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func
  }

  state = {}

  componentDidMount() {
    this.setState({checked: this.props.value ? this.props.value.checked : false})
    this.props.onChange(this.props.value ? this.props.value.checked : false)
  }

  @autobind
  save() {
    this.props.onChange(this.state.checked)
  }

  @autobind
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.save()
      event.preventDefault()
    }
  }

  render() {
    return (
      <input
        type="checkbox"
        checked={this.state.checked}
        onChange={event => this.setState({checked: event.target.checked})}
        onBlur={this.save}
        onKeyPress={this.handleKeyPress}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/Field/Edit/Checkbox/index.js